import globalDomains from '@/utils/global-domains';
import ApiCore from '@/api/index';

const StbbsApi = ApiCore(globalDomains.STBBS_AFREECATV);
export default StbbsApi;
